export const SET_STORE = 'setStore'
export const SET_STORE_SCHEDULE = 'setStoreSchedule'
export const SET_FAQS = 'setFAQs'
export const FETCH_START = 'fetchStartStorage'
export const FETCH_END = 'fetchEndStorage'
export const SET_TELEGRAM_USERS = 'setTelegramUsers'
export const FETCH_START_TELEGRAM_USERS = 'fetchStartTelegramUsers'
export const FETCH_END_TELEGRAM_USERS = 'fetchEndTelegramUsers'
export const FETCH_START_STORE_SCHEDULE = 'fetchStartStoreSchedule'
export const FETCH_END_STORE_SCHEDULE = 'fetchStopStoreSchedule'